// 원화 금액 — '₩1,234,000', LTR 격리. props: { won, style }
import React from 'react';
import { fmtKRW } from '../fmt';
import LtrText from './LtrText';

function MoneyKRW(props) {
  return <LtrText style={props.style}>{fmtKRW(props.won)}</LtrText>;
}

export default MoneyKRW;
